<template>
    <div class="ui-enter">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'ui-enter',

}

</script>

<style lang="scss">

    .ui-enter {
        margin: var(--padding) 0;

        p,
        h1,h2,h3,h4,
        ul, ol, blockquote {
            margin: 1em 0 0 0;
        }

        // h1:not(:first-child),h2:not(:first-child),h4:not(:first-child) {
        //     margin-top: var(--padding-x2);
        // }

        h1 {
            font-size: var(--title-size);
        }

        h2 {
            font-size: var(--large-size);
            // margin-bottom: calc(var(--padding) * 1.5);
            // margin-bottom: 1em;
        }

        h3{
            font-size: var(--large-size);
            // margin-bottom: 1em;
            // font-weight: bold;
        }

        h4{
            font-size: var(--large-size);
            margin-bottom: 0;
        }

        ol, ul {
            // margin-left: 2rem;

            li {
                margin: 0;
            }
        }

        ul {
            list-style-type: none;
            list-style-position: none;
            list-style-image: none;
            margin-left: .5rem;

            li {
                margin-left: 1.5rem;
                position: relative;

                &::before {
                    content: '·';
                    position: absolute;
                    left: -1.5rem;
                }
            }
        }

        .client-list ul li,
        .client-list ol li {
            margin-left: 0;
            &:before {
                content: unset;
            }
        }

        ol {
            list-style-type: none;
            list-style-position: none;
            list-style-image: none;
            margin-left: 1.5rem;

            li {
                margin-left: 1.5rem;
                position: relative;
                list-style: decimal;
            }
        }

        blockquote {
            position: relative;
            margin: 1em 0 1em 30%;
            font-size: var(--large-size);
            display: block;

            p {
                margin: 0;
            }

            em {
                font-size: var(--tiny-size);
                display: block;
                margin: var(--padding-25) 0 0;
            }
        }

        .gallery {
            display: none;
        }

        p > img,
        .wp-caption,
        .embed-image {
            display: block;
            margin: 0 auto;
            width: auto !important;
            display: table;
            max-width: 50rem;
            margin-top: 1em;
            max-height: 50rem;
            height: auto;
            clear: both;

            img {
                display: block;
                max-width: 100%;
                max-height: 100vh;
                margin: auto;
            }

            .wp-caption-text {
                margin-top: .75rem;
                font-size: var(--tiny-size);
                display: table-caption;
                caption-side: bottom;
            }
        }

        img {
            max-width: 100%;
            height: auto;
            display: block;
            margin: 0 0 var(--padding) 0;
        }

        iframe {
            max-width: 100%;
            display: block;
        }

        .embed-video {
            display: block;
            margin: var(--padding) 0;
            width: auto !important;
            position: relative;

            &::before {
                display: block;
                content: '';
                padding-top: 56.2%;
            }

            iframe {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
            }
        }

        .list-item {
            width: 100%;
            display: flex;
            // margin: 0 0 1em 0;
            margin: 0;

            h2 {
                margin-bottom: .5em;
            }

            .left-label {
                width: 7rem;
                padding-right: var(--padding-50);
                word-break: break-word;
            }

            .right-content {
                flex: 1;

//                & > p:first-child {
//                    margin-top: 0;
//                }

                & > .list-item:last-child {
                    margin-bottom: 0;
                }
            }

        }



        .link-button {
            display: block;
            line-height: 1;
            text-decoration: underline;
            text-align: center;
            cursor: pointer;
            padding: 1rem 2rem;

            &:hover {
                color: var(--white);
                background-color: var(--black);
                text-decoration: none;
            }

        }

        .left, .right {
            width: 50%;
            float: left;
            margin-top: 2em;
        }
    }

    .ui-enter {
        position: relative;

        .info:not(.accordion-info) {
            position: absolute;
            left: 0;
            top: 0;
            font-size: var(--tiny-size);
            text-transform: uppercase;
            letter-spacing:.02rem;
            margin: 0 0 var(--padding-50);
            span {
                display: block;

                &:first-child {
                    margin-bottom: 1em;
                }
            }
        }

        & > .box {
            margin: 0 var(--margin);
            display: block;

            & > p:last-child {
                // margin-bottom: 1em;
            }

            a {
                text-decoration: underline;
                &:hover {
                     text-decoration: none;
                }
            }

            h6 {
                font-size:var(--small-size);
                text-align: left;
                margin: 0;
                display: block;
                margin: var(--padding) 0;
                width: 100%;
            }
        }

        .columns-container {
            display: flex;

            &.columns-2 .gca-column {
                width: 50%;

                &:nth-child(1) {
                    width: 50%;
                    padding: 0 var(--padding-50) 0 var(--padding-x6);

                }

                &:nth-child(2) {
                    width: 50%;
                    padding: 0 var(--padding-x6) 0 var(--padding-50);
                }
            }
        }

    }

    .page-single-viewpoints {
        .ui-enter {
            img {
                margin: var(--padding-50)  0 var(--padding-50) 0;
                width: 100%;
                height: auto;
                max-width: 800px;
                max-height: 800px;
                object-fit: contain;
            }
        }
    }

    @media only screen and (max-width: 767px) {
        .ui-enter {

            ul,ol {
                // margin-left: 5rem;
                margin-left:0;
                li {
                    margin-left: 3rem;
                    &:before {
                        left:-3rem;
                    }
                }
            }

            .client-list ul li,
            .client-list ol li {
                margin-left: 0;
                &:before {
                    content: unset;
                }
            }

            & > .box {
                margin: 0 0 var(--padding-x2) 0;
            }

            img {
                max-height: 50vh;
                margin: auto;
            }

            h2 {
                // font-size: var(--title-size);
                // margin-top: 0;
            }

            .info:not(.accordion-info) {
                position: static;
                text-align: left;
                margin: var(--padding-50) 0 var(--padding-x2);
                span {
                    float: left;
                    margin: 0 1em 1em 0;
                    &:first-child {
                        width: 100%;
                        margin-bottom: .2em;
                    }
                }
            }

            blockquote {
                margin: 1em 0 1em 0;
                em {
                    margin: var(--padding-50) 0 0;
                }
            }

            .list-item {
                .left-label {
                    width: 7rem;
                }
            }

            .left, .right {
                width: 100%;
                float: none;
                margin-top: 2em;
            }

            p > img,
            .wp-caption,
            .embed-image {
                max-width: 1280px;
                max-height: 1280px;
            }

            .wp-caption img {
                width: 100%;
                max-width: 800px;
                max-height: 800px;
            }

            .columns-container {
                display: block;

                &.columns-2 .gca-column {
                    width: 100%;

                    &:nth-child(1) {
                        width: 100%;
                        padding: 0;

                    }

                    &:nth-child(2) {
                        width: 100%;
                        padding: 0;
                        display: none;
                    }
                }
            }
        }



    }

</style>
